import { render, staticRenderFns } from "./Awarded.vue?vue&type=template&id=d956297c&"
import script from "./Awarded.vue?vue&type=script&lang=js&"
export * from "./Awarded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports